import {PreferencesHelper} from "@/helpers/PreferencesHelper";
import {applyLocale} from "@/lang";

const state = {
    values: PreferencesHelper.load()
};

const mutations = {
    setPreference(state, {id, value}) {
        state.values = {...state.values, [id]: value};
        PreferencesHelper.save(state.values);
        if (id === "language") {
            applyLocale(value);
        }
    },
    reloadPreferences(state) {
        state.values = PreferencesHelper.load();
    },
    resetPreferences(state) {
        state.values = PreferencesHelper.defaults();
        PreferencesHelper.save(state.values);
    }
};

const getters = {
    preference: (state) => (id) => state.values[id]
};

export const preferences = {
    namespaced: true,
    state,
    mutations,
    getters
};
